"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RecipientDetailsEdit = _interopRequireDefault(require("./containers/RecipientDetails/RecipientDetailsEdit"));

var _useRecipientCreate = require("./hooks/useRecipientCreate");

var EditContactModule = function EditContactModule(_ref) {
  var email = _ref.email,
      onCreate = _ref.onCreate,
      onClose = _ref.onClose,
      hasInternational = _ref.hasInternational;
  (0, _useRecipientCreate.useRecipientCreate)(onCreate);
  return /*#__PURE__*/_react.default.createElement(_RecipientDetailsEdit.default, {
    key: email,
    email: email,
    hasInternational: hasInternational,
    disabledFields: {
      email: true
    },
    onClose: onClose
  });
};

EditContactModule.propTypes = {
  onCreate: _propTypes.default.func.isRequired,
  email: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func.isRequired,
  hasInternational: _propTypes.default.bool
};
EditContactModule.defaultProps = {
  hasInternational: false
};
var _default = EditContactModule;
exports.default = _default;